/**
 * Job paths + tool registry — Open/Closed extension point.
 * Add a job or reorder steps here; FiatOffRamp.tsx does not change.
 */
import type { JobId, JobPath, ToolRegistry } from './types';
import { JOBS } from './copy';
import { StatementStitchPanel } from './tools/StatementStitchPanel';
import { UtrDecodePanel } from './tools/UtrDecodePanel';
import { OffRampMatchPanel } from './tools/OffRampMatchPanel';
import { FrozenTriagePanel } from './tools/FrozenTriagePanel';
import { SofEddPanel } from './tools/SofEddPanel';

export const TOOL_REGISTRY: ToolRegistry = {
    stitch: StatementStitchPanel,
    utr: UtrDecodePanel,
    match: OffRampMatchPanel,
    triage: FrozenTriagePanel,
    sof: SofEddPanel,
};

export const JOB_PATHS: Record<JobId, JobPath> = {
    name_exit: {
        id: 'name_exit',
        title: JOBS.name_exit.title,
        blurb: JOBS.name_exit.blurb,
        primaryCta: JOBS.name_exit.primaryCta,
        primaryToolId: 'stitch',
        steps: [
            {
                toolId: 'stitch',
                title: 'Connect matching payments',
                hint: 'Start here — try the mule → seller example.',
                required: true,
                engTag: 'L2',
            },
            {
                toolId: 'utr',
                title: 'Validate a UTR',
                hint: 'Optional if you already trust the reference.',
                required: false,
                engTag: 'L2',
            },
            {
                toolId: 'match',
                title: 'Name the beneficiary',
                hint: 'Check whether the payee is a known crypto exit.',
                required: true,
                engTag: 'L1',
            },
        ],
    },
    clear_freeze: {
        id: 'clear_freeze',
        title: JOBS.clear_freeze.title,
        blurb: JOBS.clear_freeze.blurb,
        primaryCta: JOBS.clear_freeze.primaryCta,
        primaryToolId: 'triage',
        steps: [
            {
                toolId: 'triage',
                title: 'Frozen-account triage',
                hint: 'Mark NCRP UTRs as tainted; see clean releasable balance.',
                required: true,
                engTag: 'P3',
            },
            {
                toolId: 'sof',
                title: 'Source-of-funds check',
                hint: 'Optional — P2P crypto-sale pattern on inflows.',
                required: false,
                engTag: 'P3',
            },
        ],
    },
    show_all: {
        id: 'show_all',
        title: JOBS.show_all.title,
        blurb: JOBS.show_all.blurb,
        primaryCta: JOBS.show_all.primaryCta,
        primaryToolId: 'stitch',
        steps: [
            {
                toolId: 'stitch',
                title: 'Connect matching payments',
                required: true,
                engTag: 'L2',
            },
            {
                toolId: 'utr',
                title: 'Validate a UTR',
                required: false,
                engTag: 'L2',
            },
            {
                toolId: 'match',
                title: 'Name the beneficiary',
                required: true,
                engTag: 'L1',
            },
            {
                toolId: 'triage',
                title: 'Frozen-account triage',
                required: true,
                engTag: 'P3',
            },
            {
                toolId: 'sof',
                title: 'Source-of-funds check',
                required: false,
                engTag: 'P3',
            },
        ],
    },
};
